var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94899 7.91315C6.89261 7.96929 6.85098 8.03583 6.82261 8.10894L6.78975 8.22375L6.78903 8.22783L6.77809 8.34159C6.77664 8.45627 6.80576 8.5701 6.87694 8.67175C6.94819 8.77339 7.04497 8.8396 7.15337 8.87756L7.26402 8.90619L11.715 9.69032L5.88577 13.772C5.75705 13.8621 5.67054 13.9905 5.64269 14.1485C5.61486 14.3064 5.65224 14.4566 5.74235 14.5853C5.80998 14.6818 5.89908 14.7545 6.00591 14.7966L6.11824 14.8276C6.27616 14.8555 6.42641 14.8181 6.55513 14.728L12.3836 10.6468L11.5979 15.1025C11.5782 15.2147 11.5886 15.3252 11.6303 15.4279L11.6827 15.5283L11.6833 15.5291L11.7619 15.6243C11.8485 15.707 11.9583 15.7547 12.076 15.7751L12.078 15.7761C12.2273 15.8005 12.3806 15.7805 12.5138 15.6903L12.5146 15.6897C12.6517 15.5959 12.7233 15.4541 12.7504 15.3029L12.7512 15.3023L13.7459 9.65715L13.7461 9.65579C13.7644 9.54958 13.7658 9.44187 13.7405 9.33786C13.717 9.24164 13.6749 9.15238 13.6179 9.07083C13.5607 8.9892 13.4908 8.91852 13.4083 8.86349C13.319 8.80399 13.2169 8.76873 13.1107 8.75001L7.46579 7.75396L7.3553 7.74429C7.24602 7.74511 7.14137 7.77702 7.04587 7.83698L6.94899 7.91315Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHistory);
export default __webpack_public_path__ + "static/media/ArrowHistory.1db94c1ced69f3c9c8c3eb369f73f56a.svg";
export { ForwardRef as ReactComponent };